import { User } from '@fable/types'

export const isInternalUser = (user: User | null) =>
  !!user?.email?.includes('@fable.co') || !!user?.email?.includes('@scribd.com')
